import { api } from '../core';
import {
  MEDICAL_MATCH_CAN_RERUN_TAG,
  MEDICAL_MATCH_LIVE_PROCESSING_TAG,
  MEDICAL_MATCH_LIVE_STATUS_TAG,
} from '../constants';

// The endpoint answers with an empty object — a 200 only means the full
// medmatch job was created and enqueued, not that it has finished.
export type RerunMedicalMatchResponse = Record<string, never>;

export interface RerunMedicalMatchRequest {
  caseId: string;
}

const rerunMedicalMatchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    rerunMedicalMatch: builder.mutation<RerunMedicalMatchResponse, RerunMedicalMatchRequest>({
      query: ({ caseId }: RerunMedicalMatchRequest) => ({
        url: 'medical-match/rerun',
        method: 'POST',
        body: { caseId },
      }),
      // Invalidated on failure too — a 409/422 means our idea of the rerun
      // availability is out of date, so the button state needs refreshing
      // either way. Retries are off because a repeated POST would race the
      // sentinel job the first attempt created.
      invalidatesTags: (_result, _err, { caseId }) => [
        { type: MEDICAL_MATCH_CAN_RERUN_TAG, id: caseId },
        { type: MEDICAL_MATCH_LIVE_PROCESSING_TAG, id: caseId },
        { type: MEDICAL_MATCH_LIVE_STATUS_TAG, id: caseId },
      ],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useRerunMedicalMatchMutation } = rerunMedicalMatchApi;
